// NotFound.jsx
import React from 'react';
import '../../scss/NotFound.scss'; // Adjust the path as necessary

const NotFound = () => {
    return (
        <div className="not-found-container">
            <h1>404 - Not Found</h1>
            <p>
                Sorry, the page you’re looking for doesn’t exist or has been moved.
                Please check the URL or go back to the home page.
            </p>
        </div>
    );
};

export default NotFound;
